var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgBuilding = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M30.303 46.072h-9.762a4 4 0 0 0-4 4v26.927h17.762V50.072a4 4 0 0 0-4-4Z"
  }), React.createElement("path", {
    stroke: color,
    strokeDasharray: "10 6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M28.91 50.993h-6.988M28.91 55.914h-6.988M28.91 60.836h-6.988M28.91 65.77h-6.988M28.91 70.691h-6.988"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M38.303 29.492a4 4 0 0 0-4 4V77h26.395V33.492a4 4 0 0 0-4-4H38.303Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeDasharray: "10 4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M40.844 36.232h13.732M40.844 41.153h13.732M40.844 46.075h13.732M40.844 50.996h13.732M40.844 55.916h13.732M40.844 60.838h13.732"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M44.172 77.014h6.656v-6.808a3.328 3.328 0 0 0-6.656 0v6.808Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M50.577 24.928H43.85a4 4 0 0 0-4 4v.565h14.727v-.565a4 4 0 0 0-4-4Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M47.22 24.926V18"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M76.865 55.332a4.175 4.175 0 0 0 1.747-3.396 4.193 4.193 0 0 0-4.195-4.183c-.574 0-1.122.114-1.62.318.154-.407.243-.852.243-1.31a3.755 3.755 0 0 0-3.762-3.752 3.755 3.755 0 0 0-3.761 3.752c0 .877.306 1.678.816 2.327-.115-.013-.23-.013-.344-.013a4.891 4.891 0 0 0-4.897 4.883 4.85 4.85 0 0 0 1.505 3.523c-2.372.915-4.055 3.204-4.055 5.887 0 3.485 2.831 6.308 6.325 6.308 2.435 0 4.156-1.36 5.215-3.37 1.186 1.157 3.188 1.87 4.973 1.87 3.634 0 6.566-2.938 6.566-6.55.013-2.988-2.002-5.519-4.756-6.294Z"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M70.582 50.552a.5.5 0 1 0-1 0v3.487l-3.05-1.653a.5.5 0 0 0-.476.88l3.526 1.91v6.587l-4.169-2.138a.5.5 0 0 0-.456.89l4.625 2.372v13.046a.5.5 0 0 0 1 0V62.927l4.986-2.1a.5.5 0 0 0-.389-.922l-4.597 1.937v-6.68l3.186-1.907a.5.5 0 0 0-.513-.858l-2.673 1.6v-3.445Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: color,
    d: "m69.582 54.04-.12.219a.25.25 0 0 0 .37-.22h-.25Zm-3.05-1.654-.118.22.119-.22Zm-.677.201-.22-.119.22.12Zm.201.678-.119.22.12-.22Zm3.526 1.912h.25a.25.25 0 0 0-.13-.22l-.12.22Zm0 6.586-.114.223a.25.25 0 0 0 .364-.223h-.25Zm-4.169-2.138-.114.223.114-.223Zm-.673.217.223.114-.223-.114Zm.217.673.114-.222-.114.222Zm4.625 2.372h.25a.25.25 0 0 0-.136-.222l-.114.222Zm1 .04-.097-.23a.25.25 0 0 0-.153.23h.25Zm4.986-2.1.097.23-.098-.23Zm.266-.656.23-.097-.23.097Zm-.655-.266-.097-.23.097.23Zm-4.597 1.937h-.25a.25.25 0 0 0 .347.23l-.097-.23Zm0-6.68-.128-.215a.25.25 0 0 0-.122.215h.25Zm3.186-1.907.129.214-.129-.214Zm.172-.686-.214.128.215-.128Zm-.685-.172.128.214-.128-.214Zm-2.673 1.6h-.25a.25.25 0 0 0 .378.214l-.128-.215Zm-.5-3.695a.25.25 0 0 1 .25.25h.5a.75.75 0 0 0-.75-.75v.5Zm-.25.25a.25.25 0 0 1 .25-.25v-.5a.75.75 0 0 0-.75.75h.5Zm0 3.487v-3.487h-.5v3.487h.5Zm-3.418-1.433 3.049 1.653.238-.44-3.049-1.653-.238.44Zm-.34.1a.25.25 0 0 1 .34-.1l.238-.44a.75.75 0 0 0-1.017.302l.44.238Zm.101.34a.25.25 0 0 1-.1-.34l-.44-.238a.75.75 0 0 0 .302 1.017l.238-.44Zm3.526 1.91-3.526-1.91-.238.439 3.526 1.911.238-.44Zm.13 6.807v-6.586h-.5v6.586h.5ZM65.3 59.848l4.169 2.138.228-.445-4.169-2.138-.228.445Zm-.337.108a.25.25 0 0 1 .337-.108l.228-.445a.75.75 0 0 0-1.01.325l.446.228Zm.109.337a.25.25 0 0 1-.108-.337l-.445-.228a.75.75 0 0 0 .325 1.01l.228-.445Zm4.625 2.372-4.625-2.372-.228.445 4.625 2.371.228-.444Zm.136 13.268V62.887h-.5v13.046h.5Zm.25.25a.25.25 0 0 1-.25-.25h-.5c0 .414.336.75.75.75v-.5Zm.25-.25a.25.25 0 0 1-.25.25v.5a.75.75 0 0 0 .75-.75h-.5Zm0-13.006v13.006h.5V62.927h-.5Zm5.138-2.331-4.985 2.1.194.461 4.986-2.1-.195-.461Zm.134-.328a.25.25 0 0 1-.134.328l.195.46a.75.75 0 0 0 .4-.982l-.461.194Zm-.328-.133a.25.25 0 0 1 .328.133l.46-.194a.75.75 0 0 0-.982-.4l.194.461Zm-4.597 1.937 4.597-1.937-.194-.46-4.597 1.936.194.46Zm-.347-6.91v6.68h.5v-6.68h-.5Zm3.308-2.122-3.186 1.907.256.43 3.187-1.908-.257-.429Zm.086-.343a.25.25 0 0 1-.086.343l.257.43a.75.75 0 0 0 .258-1.03l-.429.257Zm-.343-.086a.25.25 0 0 1 .343.086l.429-.257a.75.75 0 0 0-1.029-.258l.257.43Zm-2.673 1.6 2.673-1.6-.257-.429-2.672 1.6.256.429Zm-.378-3.659v3.444h.5v-3.444h-.5Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10 77h75"
  }));
};
export default SvgBuilding;